import React, { useEffect } from "react";
import { Stack } from "@mui/material";

import {
  HubHookFormInput,
  HubHookFormSelect,
  HubHookFormWrapper,
} from "../../components";
import ManageMoldButtons from "./ManageMoldButtons";
import { useGetPartMoldData, usePostCreateMold } from "../../hooks";

const moldTypes = ["Manual", "Automatic"]?.map((label, id) => ({
  id,
  label,
}));

const ManageMoldForm = ({ partId, locationId, onClose = () => {} }) => {
  const { mutate: create, data, isLoading, isSuccess } = usePostCreateMold();
  const { data: mold } = useGetPartMoldData({ partId, locationId });

  useEffect(() => {
    if (isSuccess) onClose();
  }, [data, isSuccess]);

  const onSubmit = (formData) => {
    const payload = {
      partId,
      locationId,
      name: formData?.name,
      cavities: Number(formData?.cavities),
      automatic: !!formData?.automatic,
    };
    create(payload);
  };

  const defaultValues = {
    name: mold?.moldNumber,
    cavities: mold?.cavities,
    automatic: mold?.automatic,
  };

  return (
    <HubHookFormWrapper onSubmit={onSubmit} defaultValues={defaultValues}>
      <Stack gap="25px">
        <Stack gap="10px">
          <HubHookFormInput
            name="name"
            label="Mold Name"
            disabled={isLoading}
            required
          />
          <Stack direction="row" gap="10px">
            <HubHookFormInput
              name="cavities"
              label="Cavities"
              defaultValue={1}
              disabled={isLoading}
              isNumber
              required
            />
            <HubHookFormSelect
              name="automatic"
              label="Type"
              options={moldTypes}
              disabled={isLoading}
              defaultValue={true}
              required
            />
          </Stack>
        </Stack>
        <ManageMoldButtons onClose={onClose} disabled={isLoading} />
      </Stack>
    </HubHookFormWrapper>
  );
};

export default ManageMoldForm;
